export default __webpack_public_path__ + "static/hero-image3_4-87dc9a944efb8a4fc9fe33d50d637fb5.png";